import { c as _c } from "react/compiler-runtime";
import { LanguageCodeEnum, getLocaleByLanguageCode } from '@systemeio/ui';
import { useLanguageSwitcher } from 'shared/components/language-switcher/hooks/use-language-switcher';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import useUser from '../../hooks/use-user';
import { LanguageSwitcher } from './language-switcher';
export function DesktopLanguageSwitcher() {
  const $ = _c(10);
  const {
    i18n
  } = useLocoTranslation();
  const {
    isLoading
  } = useUser();
  const {
    handleChangeLanguage,
    isChangingLanguage
  } = useLanguageSwitcher();
  if (isLoading || !i18n) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="bg-text-secondary rounded-xs h-6 w-[44px] animate-pulse" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const t0 = i18n.language as LanguageCodeEnum;
  let t1;
  if ($[1] !== t0) {
    t1 = getLocaleByLanguageCode(t0);
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isChangingLanguage && "animate-pulse";
  let t3;
  if ($[3] !== t2) {
    t3 = twMerge("h-full flex items-center justify-around gap-2 focus:outline-hidden border-b-4 border-transparent focus-visible:border-brand-primary", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleChangeLanguage || $[6] !== isChangingLanguage || $[7] !== t1 || $[8] !== t3) {
    t4 = <LanguageSwitcher selectedLanguage={t1} changeLanguage={handleChangeLanguage} isFetching={isChangingLanguage} buttonClassName={t3} labelClassName="w-5 text-sm font-bold text-background-secondary/90" wrapperClassName="h-full" />;
    $[5] = handleChangeLanguage;
    $[6] = isChangingLanguage;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}